import React, { FC, useEffect, useMemo, useRef } from 'react'
import { useIsPreview } from '@ui/hooks'
interface DescriptionProps extends React.HTMLAttributes<HTMLDivElement> {
  label?: string
  description?: string
}

const Description: FC<DescriptionProps> = ({ label = '', description = '', className = '' }) => {
  const isPreview = useIsPreview()
  const ref = useRef(null)

  useEffect(() => {
    const handlePlayVideo = () => {
      const videoElement = Array.from(document.getElementsByTagName('video'))
      if (videoElement.length) {
        videoElement.forEach(async (element: HTMLMediaElement) => {
          if (!element.controls) {
            element.play()
          }
        })
      }
    }
    window.addEventListener('touchstart', handlePlayVideo)
    return () => {
      window.removeEventListener('touchstart', handlePlayVideo)
    }
  }, [ref])

  const editedDescription = useMemo(() => {
    if (!isPreview) return description
    if (!description) return ''
    return description
      .replace(/http:\/\//gm, 'https://')
      .replace(/<video([\S\s]*?)>([\S\s]*?)<\/video>/g, (u: string) => {
        return (u || '').replace(`controls="controls"`, (x) => {
          if (u.includes('#audio')) return x
          return 'autoplay loop muted playsinline'
        })
      })
      .replace(/<iframe/g, '<figure class="image is-16by9"><iframe class="has-ratio"')
      .replace(/<\/iframe>/g, '</iframe></figure>')
  }, [description])

  if (!description) return null

  return (
    <div className={`description ${className || ''}`} ref={ref}>
      {label && (
        <div className="columns">
          <div className="column is-4 is-hidden-mobile">
            <div className="title--large">{label}</div>
          </div>
          <div className="column is-8">
            <div
              className="rich-text"
              dangerouslySetInnerHTML={{
                __html: editedDescription
              }}
            />
          </div>
        </div>
      )}
      {!label && (
        <div
          className="rich-text"
          dangerouslySetInnerHTML={{
            __html: editedDescription
          }}
        />
      )}
    </div>
  )
}

export default Description
